// IMPORT PACKAGE REFERENCES
import { Checkbox, Grid, IconButton, ListItem, ListItemSecondaryAction, ListItemText, TextField, Box } from '@material-ui/core';
import React, { memo } from 'react';
import { getIcon } from '../../../icon/icon';
import DropdownSelect from '../../dropdown-select/DropdownSelect';
import styles from './ListableRulesItem.module.scss'; // Import css modules stylesheet as styles
import { RuleType, ValueType } from '../../../state/constants/RuleType';
import { createTargetFields } from '../../../state/constants/TargetFields';
import { useTranslation } from 'react-i18next';
import Textbox, { Option } from 'components/textbox/Textbox';
import { FixMeLater } from 'types/FixMeLaterType';
import { withTranslation } from "react-i18next";

interface ListableRulesItemProps extends ListableRulesCardDataModel {
    // Fields
    selectedItems: FixMeLater,
    toolbarShowing: boolean,
    disabled: boolean,
    modelType: string,
    fieldName?: string,

    // Functions
    handleCheck: FixMeLater,
    handleDelete: FixMeLater
}

export interface ListableRulesCardDataModel {
    // Fields
    id: string,
    fieldNameValue: string,
    value?: string[] | boolean,
    options?: Option[],

    // Functions
    handleFieldNameChange: FixMeLater,
    handleValueChange: (data: string[] | boolean, id: string) => void
}
function ListableRulesItem(props: ListableRulesItemProps) {
    // Page Utilities
    const [t, i18n] = useTranslation()
    const TargetFields = createTargetFields()

    return (
        <ListItem disableGutters={true}>
            {props.toolbarShowing && (
                <Box className={styles.checkbox}>
                    <Checkbox
                        onClick={() => props.handleCheck(props.id)}
                        checked={props.selectedItems.hasOwnProperty(props.id)}
                    />
                </Box>
            )}
            <ListItemText>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <DropdownSelect
                            disabled={props.disabled}
                            label={t('target-field.field-name')}
                            handleChange={(value) => {
                                props.handleFieldNameChange(TargetFields[props.modelType].RULE[value], props.id);
                            }}
                            data={props.modelType ? Object.values(TargetFields[props.modelType].RULE) : []}
                            value={TargetFields[props.modelType].RULE[props.fieldNameValue] ? TargetFields[props.modelType].RULE[props.fieldNameValue].key : ""}
                            valueName={props.fieldName}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        {TargetFields[props.modelType].RULE[props.fieldNameValue] != null
                            && TargetFields[props.modelType].RULE[props.fieldNameValue].FilterType === RuleType.Bool.key
                            && typeof props.value === "boolean" ?
                            <DropdownSelect
                                disabled={props.disabled}
                                label={t('common.value')}
                                handleChange={(value: boolean) => props.handleValueChange(value, props.id)}
                                data={[true, false]}
                                value={props.value.toString()}
                                valueName={"contentType"}
                            /> : typeof props.value !== "boolean" ?
                                <Textbox
                                    options={props.options}
                                    value={props.value}
                                    handleChange={(data: string[]) => props.handleValueChange(data, props.id)}
                                    label={t('common.value')}
                                    disabled={props.disabled}
                                /> :
                                null
                        }
                    </Grid>
                </Grid>
            </ListItemText>
            {props.toolbarShowing && (
                <ListItemSecondaryAction>
                    <IconButton
                        onClick={() => props.handleDelete(props.options)}
                        edge="end"
                        aria-label="delete"
                    >
                        {getIcon("trash.svg", styles.icon)}
                    </IconButton>
                </ListItemSecondaryAction>)}
        </ListItem>
    );
}

export default memo(ListableRulesItem)